import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { UI_CONFIG } from '../ui.config';
import { UiConfig } from '../ui.interface';

type ImageThumbnailSize =
  | 'xsmall'
  | 'small'
  | 'mid'
  | 'large'
  | 'xlarge'
  | 'fluid';

@Component({
  selector: 'fl-image-thumbnail',
  template: `
    <figure class="ImageContainer">
      <img [src]="getDisplayImage()" [alt]="alt" class="Image" (error)="onImageFetchError()">
    </figure>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./image-thumbnail.component.scss'],
})
export class ImageThumbnailComponent implements OnChanges {
  private forcePlaceholder = false;

  @HostBinding('attr.size')
  @Input()
  size: ImageThumbnailSize = 'mid';
  @Input() alt?: string;
  @Input() src?: string;
  @HostBinding('attr.clickable')
  @Input()
  clickable = true;
  @HostBinding('attr.circular')
  @Input()
  circular: boolean;
  @Input() placeholder: string;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    @Inject(UI_CONFIG) private uiConfig: UiConfig,
  ) {
    this.placeholder = `${this.uiConfig
      .assetsBaseUrl}/image-thumbnail-placeholder.svg`;
  }

  getDisplayImage() {
    if (this.forcePlaceholder) {
      return this.placeholder;
    }

    return this.src || this.placeholder;
  }

  onImageFetchError() {
    if (!this.forcePlaceholder) {
      // Well this sucks. Show the placeholder for now.
      this.forcePlaceholder = true;
      this.changeDetectorRef.markForCheck();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const changedInputs = Object.keys(changes);
    if (changedInputs.includes('src')) {
      // There's a possibility that the new `src` can be a working image. Flip
      // forcePlaceholder to false to check.
      this.forcePlaceholder = false;
    }
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/es/webapp/src/app/@shared/ui/image-thumbnail/image-thumbnail.component.ts